"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDefault = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
function useDefault(value, defaultValue, onChange) {
    var isControlledRef = react_1.useRef(false);
    var valueRef = react_1.useRef(defaultValue);
    var _a = tslib_1.__read(react_1.useState(defaultValue), 2), internalValue = _a[0], setInternalValue = _a[1];
    react_1.useEffect(function () {
        if (isControlledRef.current) {
            valueRef.current = value;
        }
    }, [value]);
    var handleInternalChange = react_1.useCallback(function (newValue) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // 回调形式更新
        if (typeof newValue === "function") {
            // eslint-disable-next-line no-param-reassign
            newValue = newValue(valueRef.current);
        }
        setInternalValue(newValue);
        valueRef.current = newValue;
        if (typeof onChange === "function") {
            onChange.apply(void 0, tslib_1.__spread([newValue], args));
        }
    }, [onChange]);
    var handleChange = react_1.useCallback(function (newValue) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // 回调形式更新
        if (typeof newValue === "function") {
            // eslint-disable-next-line no-param-reassign
            newValue = newValue(valueRef.current);
        }
        if (typeof onChange === "function") {
            onChange.apply(void 0, tslib_1.__spread([newValue], args));
        }
    }, [onChange]);
    // 受控模式
    if (isControlledRef.current || typeof value !== "undefined") {
        isControlledRef.current = true;
        return [value, handleChange];
    }
    // 非受控模式
    return [internalValue, handleInternalChange];
}
exports.useDefault = useDefault;
//# sourceMappingURL=use-default.js.map